export default ({
  addressByRepository,
  maps,
  data
}) => {
  return async (payload) => {
    const {
      onSuccess,
      onError,
      actions,
      dispatch,
      getState,
			data: payloadData
    } = payload

    try {
      const geolocation = await addressByRepository.fetchGeolocationByAddress({
        data: {
					...data,
					...payloadData
				},
        actions,
        maps,
        dispatch,
        getState
      })

      onSuccess({ geolocation })
    } catch(e) {
      console.log(e)

      onError()
    }
  }
}
